import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Review = () => {
    return (
        <div className="otpBank-review">
            <FullWrapper>
                <div className="otpBank-reviewWrapper">
                    <div className="otpBank-reviewTitle">Клиент о нас</div>
                    <div className="otpBank-reviewMiddle">
                        Очень профессиональный партнер, глубокая экспертиза и&nbsp;отличные
                        результаты при&nbsp;ограниченном бюджете. Вовлеченная команда, работающая
                        как центр экспертизы, всегда готовая предложить эффективное решение.
                        Надеемся на&nbsp;долгосрочное сотрудничество.<span>»</span>
                    </div>
                    <div className="otpBank-reviewBottom">
                        <div className="otpBank-reviewBottomInfo">
                            <div className="otpBank-reviewBottomAuthor">Анастасия Глаголева</div>
                            <div className="otpBank-reviewBottomPosition">Маркетолог ОТП Банка</div>
                        </div>
                        <img
                            src="/images/svg/otp-bank/reviewLogo.svg"
                            alt="reviewLogo"
                            className="otpBank-reviewBottomLogo"
                        />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Review;
